import { getBrowserLang } from '@locl/core'

const defaultLocale = 'en-GB'
const langMap: { [key: string]: string } = {
  fr: 'fr-FR',
  en: 'en-GB',
  pt: 'pt-PT',
  zh: 'zh-Hant-HK',
}

/**
 * Gets the application locale.
 *
 * @returns {string} The locale (e.g., 'fr-FR', 'en-GB').
 */
export function getWmLocale(): string {
  // Retrieve the locale from the storage
  let locale = window.localStorage.getItem('wm-locale')

  // Validate the stored locale
  if (locale && !Object.values(langMap).includes(locale)) {
    locale = null
  }

  // If not locale, try to resolve using the browser language,
  // or fallback to default
  if (!locale) {
    locale = langMap[getBrowserLang()] || defaultLocale
    window.localStorage.setItem('wm-locale', locale)
  }

  return locale
}
